import { Link } from 'react-router-dom';
import { DashboardLayout } from '../components/DashboardLayout';
import { Icon, type IconName } from '../components/Icon';

interface ComingSoonPageProps {
    eyebrow?: string;
    title: string;
    description: string;
    icon: IconName;
    features?: string[];
}

/**
 * Placeholder commun utilisé pour les pages encore non implémentées
 * (Documentation, API, Mon compte, etc.). Design cohérent avec le dashboard.
 */
export function ComingSoonPage({
    eyebrow,
    title,
    description,
    icon,
    features,
}: ComingSoonPageProps) {
    return (
        <DashboardLayout>
            <main className="dash-main">
                <section className="coming-soon">
                    <div className="coming-soon-icon" aria-hidden>
                        <Icon name={icon} size={32} />
                    </div>
                    {eyebrow && <span className="dash-eyebrow">{eyebrow}</span>}
                    <h1>{title}</h1>
                    <p className="coming-soon-desc">{description}</p>

                    <div className="coming-soon-badge">
                        <span className="coming-soon-pulse" aria-hidden />
                        Bientôt disponible
                    </div>

                    {features && features.length > 0 && (
                        <ul className="coming-soon-list">
                            {features.map((f) => (
                                <li key={f}>
                                    <Icon name="check" size={14} />
                                    <span>{f}</span>
                                </li>
                            ))}
                        </ul>
                    )}

                    <Link to="/dashboard" className="btn-ghost coming-soon-back">
                        <Icon name="arrow-right" size={14} style={{ transform: 'rotate(180deg)' }} />
                        Retour au tableau de bord
                    </Link>
                </section>
            </main>
        </DashboardLayout>
    );
}
